import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { UnidadesPageQuery, UnidadesPageQueryVariables } from './__generated__/UnidadesPageQuery';

const UNIDADES_QUERY = gql`
  query UnidadesPageQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    unidades(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_unidade
      dsc_nome_unidade
    }
  }
`;

const useUnidadesPageQuery = (variables: UnidadesPageQueryVariables) => {
  return useQuery<UnidadesPageQuery, UnidadesPageQueryVariables>(UNIDADES_QUERY, {
    variables,
  });
};

const useUnidadesLazyQuery = () => {
  return useLazyQuery<UnidadesPageQuery, UnidadesPageQueryVariables>(UNIDADES_QUERY);
};

export { useUnidadesPageQuery, useUnidadesLazyQuery };
